// E-19: pure description of the v1-vs-v2 EDIT divergence for a wheel card.
//
// Extracted from WheelCardThreeDotMenu.jsx (handleEdit + the EDIT menu item's
// label/disabled logic). A v2 wheel edits in the new builder (/builder/:id); a
// v1 (legacy) wheel opens the LegacyWheelModal instead of navigating. A synced
// clone (is_cloned + live-or-locked) cannot be edited at all.

// Where "Edit" should take a wheel.
//   version === 2 -> hard nav to the builder
//   otherwise     -> open the LegacyWheelModal (no navigation)
export const editTargetForWheel = (wheel) =>
  wheel?.version === 2
    ? { kind: "builder", href: `/builder/${wheel?.id}` }
    : { kind: "legacy-modal" };

// A cloned wheel that is live or locked stays in sync with its source and so
// cannot be edited.
export const isSyncedCloneUneditable = (wheel) =>
  Boolean(wheel?.is_cloned && (wheel?.is_live || wheel?.is_locked));

// The EDIT menu-item label reflects that uneditable state.
export const editItemLabel = (wheel) =>
  isSyncedCloneUneditable(wheel) ? "Cannot Edit a Synced Clone" : "Edit";
